/** Title-case place names, including hyphenated cities (e.g. "stoke-on-trent" → "Stoke-On-Trent"). */
export function titleCasePlaceName(str: string): string {
  if (!str?.trim()) return '';
  return str
    .trim()
    .replace(/(^|[\s\-/])(\w)(\w*)/g, (_, sep, first, rest) => sep + first.toUpperCase() + rest.toLowerCase());
}

/** Title-case the city segment in pick-up / delivery timeline descriptions. */
export function titleCaseTimelineStopExplanation(text: string): string {
  return text.replace(
    /^((?:Picked up|Delivered) - Stop \d+, )(.+?)(\s*\(\d+ min late\))?$/i,
    (_, prefix, city, suffix) => `${prefix}${titleCasePlaceName(city)}${suffix ?? ''}`,
  );
}
